var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 83,
    viewBox: "0 0 86 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589844,
    width: 84.8211,
    height: 82.4043,
    rx: 24,
    fill: "url(#paint0_linear_47_66225)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 36.958C46.5227 36.958 49.3786 34.0572 49.3786 30.479C49.3786 26.9007 46.5227 24 42.9998 24C39.4769 24 36.6211 26.9007 36.6211 30.479C36.6211 34.0572 39.4769 36.958 42.9998 36.958Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0024 57.7092C32.008 57.7092 23.0166 48.8435 22.5905 37.7799C22.5726 37.3341 22.9247 36.9609 23.3636 36.9609H31.6789C32.0871 36.9609 32.4188 37.2849 32.4469 37.697C32.822 43.2793 37.4121 47.7032 42.9998 47.7032C48.5876 47.7032 53.1802 43.2793 53.5527 37.697C53.5809 37.2823 53.9125 36.9609 54.3208 36.9609H62.6361C63.0749 36.9609 63.427 37.3341 63.4092 37.7799C62.9882 48.8435 53.9968 57.7092 43.0024 57.7092Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_66225",
    x1: 43.0004,
    y1: 0,
    x2: 43.0004,
    y2: 82.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD235"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhAppIcon);
export default __webpack_public_path__ + "static/media/AH-App-Icon.7d9c152732e82298b004342b0875882b.svg";
export { ForwardRef as ReactComponent };